import React from 'react';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import OfferTable from '../../../generic-components/special-offer-tables/special-offer-table';
import uuid from 'node-uuid';
import R from 'ramda';

const StepThree = ({
  data,
  onTextFieldChangeWithKeyPath,
  updateTableCell,
  productType,
  rates,
  nonStandardTemplateType,
  goToStep,
  commissionPercentage,
  nettCommission,
  rateType,
  contractingPeriod,
  addAnotherNewOffer,
  }) => {
  const validDatesOfTravel = data.validDatesOfTravel.filter(dateSet => dateSet.fromDate || dateSet.toDate);
  const validDatesOfSale = data.validDatesOfSale.filter(dateSet => dateSet.fromDate || dateSet.toDate);
  const dataToSave = R.call(R.compose(
    R.merge(R.__, { validDatesOfSale, validDatesOfTravel }),
    R.omit(['title', !validDatesOfTravel.length ? 'validDatesOfTravel' : '', !validDatesOfSale.length ? 'validDatesOfSale' : ''])
  ), data);
  dataToSave._id = `new-${uuid.v1()}`;
  if (data.rate === 'rateAmount') {
    dataToSave.rates = rates;
    dataToSave.commissionPercentage = commissionPercentage;
    dataToSave.nettCommission = nettCommission;
    dataToSave.rateType = rateType;
    dataToSave.nonStandardTemplateType = nonStandardTemplateType;
  }
  return (
    <div style={{ overflow: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <div style={{ padding: '36px' }}>
        <OfferTable
          {...R.merge(data, { validDatesOfSale, validDatesOfTravel })}
          withEditableRateTable
          style={{ width: '100%' }}
          rates={rates}
          nonStandardTemplateType={nonStandardTemplateType}
          productType={productType}
          contractingPeriod={contractingPeriod}
          updateTableCell={updateTableCell}
          updateFieldValue={(keyPath, value) => onTextFieldChangeWithKeyPath({ keyPath: ['data', ...keyPath], value })}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' }}>
        <FlatButton
          label="back"
          secondary
          onTouchTap={() => goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 })}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <FlatButton
            secondary
            label="Add Another"
            onTouchTap={() => addAnotherNewOffer(dataToSave)}
            labelStyle={{ fontWeight: '600' }}
          />
        </div>
      </div>
    </div>
  );
};

export default StepThree;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/3-step-offers.jsx